





/* jshint nomen:false */
define(['leaflet', 't', 'unitFormatConverter/unitFormatConverter'], function(L, T, units) {
    'use strict';

    var iconsMapping = {
            'Unknown': 'danger',
            'Accident': 'accident',
            'Fog': 'danger',
            'Dangerous Conditions': 'danger',
            'Rain': 'danger',
            'Ice': 'ice',
            'Jam': 'incident',
            'Lane Closed': 'laneclosed',
            'Road Closed': 'roadclosed',
            'Road Works': 'roadwork',
            'Wind': 'danger',
            'Flooding': 'danger',
            'Detour': 'danger',
            'Cluster': ''
        },

        messageTemplate = new T(
            '<div class="traffic-details">' +
            '    <div class="traffic-icon">' +
            '        <div class="icon-circle-{{=incidentSeverity}}">' +
            '            <div class="icon-{{=icon}}-white"></div>' +
            '        </div>' +
            '    </div>' +
            '    {{roadNumber}}' +
            '        <div class="road-shield">{{=roadNumber}}</div>' +
            '    {{/roadNumber}}' +
            '    <div class="traffic-description">' +
            '        <div class="incident-category">{{=incidentCategory}}</div>' +
            '        <div' +
            '            class="incident-delay-length"' +
            '            {{!delaySeconds}}' +
            '                {{!lengthMeters}}' +
            '                    style="display:none;"' +
            '                {{/!lengthMeters}}' +
            '            {{/!delaySeconds}}' +
            '        >' +
            '            {{delaySeconds}}' +
            '                <div class="incident-delay">{{=time}}</div>' +
            '            {{/delaySeconds}}' +
            '            {{lengthMeters}}' +
            '                <div class="incident-length">{{=distance}}</div>' +
            '            {{/lengthMeters}}' +
            '        </div>' +
            '    </div>' +
            '</div>'
        ),

        clusterPopupTemplate = new T(
            '<div>' +
            '    <div><b>Incidents in this area: {{=incidentsNo}}</b></div>' +
            '    <hr/>' +
            '    <div><b>{{=features.length}} most severe incidents</b>' +
            '        <span style="color: lightgray">(Ordered by severity and delay)</span>' +
            '    </div>' +
            '    <hr/>' +
            '    <div style="font-weight: bold">' +
            '        <div class="cluster-popup-category-column">Category</div>' +
            '        <div class="cluster-popup-length-column">Length</div>' +
            '        <div class="cluster-popup-streets-column">Streets</div>' +
            '        <div style="clear: both"></div>' +
            '        <hr/>' +
            '    </div>' +
            '    {{@features}}' +
            '        <div>' +
            '            <div class="cluster-popup-category-column">' +
            '                <div class="traffic-icon">' +
            '                    <div class="icon-circle-{{=_val.properties.incidentSeverity}}">' +
            '                        <div class="icon-{{=_val.properties.icon}}-white"></div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '            <div class="cluster-popup-length-column">' +
            '                {{=_val.properties.formattedLength}}' +
            '            </div>' +
            '            <div class="cluster-popup-streets-column">' +
            '                <div><span>From:</span>{{=_val.properties.from}}</div>' +
            '                <div><span>To:</span>{{=_val.properties.to}}</div>' +
            '            </div>' +
            '            <div style="clear: both"></div>' +
            '            <hr/>' +
            '        </div>' +
            '    {{/@features}}' +
            '</div>'
        );

    function trafficIncidentMessage(info, imperialDistance) {
        info.distance = units.formatDistance(info.lengthMeters, imperialDistance);
        info.time = units.formatTime(info.delaySeconds);
        info.incidentSeverity = info.incidentSeverity || 'unknown';
        info.icon = iconsMapping[info.incidentCategory];
        return messageTemplate.render(info);
    }

    function clusterClickHandler(bounds, latlng) {
        if (bounds) {
            return function() {
                this._map.fitBounds(bounds);
            };
        }
        return function() {
            this._map.setZoomAround(latlng, this._map.getZoom() + 2);
        };
    }

    function compareDelays(p1, p2) {
        var d1 = p1.delaySeconds || 0;
        var d2 = p2.delaySeconds || 0;
        return d2 - d1;
    }

    function compareSeverity(p1, p2, severity) {
        var is1 = p1.incidentSeverity;
        var is2 = p2.incidentSeverity;
        if (is1 === severity) {
            return -1;
        } else if (is2 === severity) {
            return 1;
        }
        return 0;
    }

    function featuresComparator(f1, f2) {
        var severities = ['major', 'moderate', 'minor', 'unknown', 'undefined'];
        var severityComparisonResult = 0;
        var i;

        var p1 = f1.properties;
        var p2 = f2.properties;

        if (p1.incidentSeverity === p2.incidentSeverity) {
            return compareDelays(p1, p2);
        }

        for (i = 0; i < severities.length; ++i) {
            severityComparisonResult = compareSeverity(p1, p2, severities[i]);
            if (severityComparisonResult !== 0) {
                return severityComparisonResult;
            }
        }

        return severityComparisonResult;
    }

    function formatLength(lengthInMeters) {
        if (!lengthInMeters) {
            return '---';
        }

        if (lengthInMeters > 1000) {
            return (lengthInMeters / 1000).toPrecision(3) + ' km';
        }
        return lengthInMeters + ' m';
    }

    function updateIconForCluster(iconOptions, feature) {
        iconOptions.icon = null;
        iconOptions.content.content = feature.properties.clusterSize < 100 ? feature.properties.clusterSize : '99+';
        this.setIcon(L.svgIcon(iconOptions));
        this.setLatLng(feature.geometry.coordinates.reverse());
    }

    function updatePopupForCluster(feature) {
        var i;
        var popupContent;
        var featuresToShow = feature.properties.features.sort(featuresComparator).slice(0, 4);
        for (i = 0; i < featuresToShow.length; ++i) {
            featuresToShow[i].properties.icon = iconsMapping[featuresToShow[i].properties.incidentCategory];
            featuresToShow[i].properties.formattedLength = formatLength(featuresToShow[i].properties.lengthMeters);
        }
        popupContent = clusterPopupTemplate.render({
            features: featuresToShow,
            incidentsNo: feature.properties.features.length
        });
        if (this.getPopup()) {
            this.setPopupContent(popupContent);
        } else {
            this.bindPopup(popupContent, {autoPan: false});
        }
    }

    function updateIconForMarker(iconOptions, feature) {
        iconOptions.content = null;
        iconOptions.icon.icon = 'icon-' + iconsMapping[feature.properties.incidentCategory] + '-white';
        this.setIcon(L.svgIcon(iconOptions));
        this.setLatLng(feature.geometry.coordinates.reverse());
    }

    function updatePopupForMarker(imperialDistance, feature) {
        var popupContent = trafficIncidentMessage(feature.properties, imperialDistance);
        if (this.getPopup()) {
            this.setPopupContent(popupContent);
        } else {
            this.bindPopup(popupContent, {className: 'incidents-popup'});
        }
    }

    function getIconOptions(feature, icon, content) {
        var defaultIcon = { iconSize: [20, 20], iconAnchor: [0, 0], icon: '' };
        var defaultContent = '';

        var iconToUse = typeof icon === 'undefined' ? defaultIcon : icon;
        var contentToUse = typeof content === 'undefined' ? defaultContent : content;

        var severity = feature.properties.incidentSeverity || 'unknown';

        return {
            icon: iconToUse,
            popupAnchor: [0, -5],
            background: { iconSize:  [20, 20], iconAnchor:  [10, 10], icon: 'icon-circle-' + severity },
            content: {
                content: contentToUse,
                iconSize: [20, 20],
                iconAnchor: [0, 0],
                style: { 'color': '#fff', 'font-weight': 'bold', 'font-size': '11px' }
            }
        };
    }

    function createMarker(feature, latlng, imperialDistance) {
        var iconOptions = getIconOptions(feature);
        var marker = L.marker(latlng, {icon: L.svgIcon(iconOptions)});
        marker._updateIcon = updateIconForMarker.bind(marker, iconOptions);
        marker._updatePopup = updatePopupForMarker.bind(marker, imperialDistance);
        marker._updateIcon(feature);
        marker._updatePopup(feature);
        return marker;
    }

    function createCluster(feature, latlng, createPopup) {
        var content = feature.properties.clusterSize < 100 ? feature.properties.clusterSize : '99+';
        var iconOptions = getIconOptions(feature, null, content);
        var marker = L.marker(latlng, {icon: L.svgIcon(iconOptions)});

        if (createPopup) {
            marker._updateIcon = updateIconForCluster.bind(marker, iconOptions);
            marker._updatePopup = updatePopupForCluster.bind(marker);
            marker._updateIcon(feature);
            marker._updatePopup(feature);
        } else {
            marker.on('click', clusterClickHandler(feature.properties.clusterBounds, latlng));
        }

        return marker;
    }

    return function(feature, latlng, imperialDistance, options) {
        if (!feature || !feature.properties) {
            return null;
        }
        if (feature.properties.clusterSize) {
            return createCluster(feature, latlng, options.createPopupForCluster);
        }
        return createMarker(feature, latlng, imperialDistance);
    };
});



// WEBPACK FOOTER //
// ./display/layers/defaultIncidentsLayer.js